import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Spinner, Button, Form, Modal, Table } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';

export const QuickLinks = () => {
	const { link, accessToken, setAccessToken, getQuickLinksLoad, quickLinks, setQuickLinks } = useContext(AppContext);

	const [serverError, setServerError] = useState(false);
	const [addLinkModal, setAddlinkModal] = useState(false);
	useEffect(() => {
		if (!addLinkModal) {
			setLinkEdit();
		}
	}, [addLinkModal]);
	const [addLinkLoad, setAddLinkLoad] = useState(false);
	const [servReqErr, setServReqErr] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const [urlReqErr, setUrlReqErr] = useState(false);
	const postAddLink = (service, website, url) => {
		apiRequest({
			url: `${link}api/cs/add/quick/link/`,
			method: 'POST',
			data: {
				name: service,
				website: website,
				link: url,
			},
			token: accessToken,
			setLoading: setAddLinkLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setAddlinkModal(false);
				setQuickLinks(data);
			},
			onError: (err) => {
				setServerError(true);
				setTimeout(() => { setServerError(false) }, 5000);
			}
		});
	}
	const postUpdateLink = (service, website, url) => {
		apiRequest({
			url: `${link}api/cs/edit/quick/link/`,
			method: 'POST',
			data: {
				q_id: linkEdit.id.substring(1),
				name: service,
				website: website,
				link: url,
			},
			token: accessToken,
			setLoading: setAddLinkLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setAddlinkModal(false);
				setQuickLinks(data);
			},
			onError: (err) => {
				setServerError(true);
				setTimeout(() => { setServerError(false) }, 5000);
			}
		});
	}
	const [linkEdit, setLinkEdit] = useState();
	const addLink = (e) => {
		e.preventDefault();
		let service = e.target.service.value;
		let website = e.target.website.value;
		let url = e.target.link.value;
		if (service === "") {
			setServReqErr(true);
			setTimeout(() => { setServReqErr(false) }, 5000);
		}
		if (website === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (url === "") {
			setUrlReqErr(true);
			setTimeout(() => { setUrlReqErr(false) }, 5000);
		}
		if (service !== "" && website !== "" && url !== "") {
			if (linkEdit !== undefined) {
				postUpdateLink(service, website, url);
			} else {
				postAddLink(service, website, url);
			}

		}
	}
	const [deleteId, setDeleteId] = useState();
	const [deleteLoad, setDeleteLoad] = useState(false);
	const deleteLink = (id) => {
		$.confirm({
			title: 'Confirm delete',
			content: 'Do you want to delete the link ?',
			type: 'blue',
			typeAnimated: true,
			buttons: {
				ok: {
					text: 'Delete',
					btnClass: 'btn-blue',
					action: function () {
						apiRequest({
							url: `${link}api/cs/delete/quick/link/`,
							method: 'POST',
							data: {
								q_id: id.substring(1),
							},
							token: accessToken,
							setLoading: setDeleteLoad,
							setAccessToken: setAccessToken,
							onSuccess: (data) => {
								setQuickLinks(data);
							},
							onError: () => {
								setServerError(true);
								setTimeout(() => { setServerError(false) }, 5000);
							}
						});
					}
				},
				cancel: function () {
					setDeleteId();
				}
			}
		});

	}
	return (
		<Container className="py-3">
			<Row className='bdr2 br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2" >
					<span>{getQuickLinksLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Quick links.'}</span>
					<Button onClick={() => { setAddlinkModal(true) }} className="btn-t1" ><i className="bi bi-plus-circle"></i> Add new</Button>
				</Col>
				<Col xs={12} sm={12} md={12} lg={12} className="px-0">
					{
						quickLinks !== undefined ? (
							Object.keys(quickLinks).length > 0 ? (
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Service</span></th>
											<th><span className="tp2" >Website</span></th>
											<th><span className="tp2" >Options</span></th>
										</tr>
									</thead>
									<tbody>
										{
											Object.keys(quickLinks).map((qlink, qli_i) => (
												<tr key={`q_link_${qli_i}`} >
													<td ><span className="ts1 f16"><b>{quickLinks[qlink].name}</b></span></td>
													<td >
														<span className="ts2 f16 d-grid">{quickLinks[qlink].website}</span>
														<a href={quickLinks[qlink].link} target="_blank">{quickLinks[qlink].link}</a>
													</td>
													<td className="quick-link">
														<Button onClick={() => {
															setLinkEdit({ id: qlink, data: quickLinks[qlink] });
															setAddlinkModal(true);
														}} className="btn-t1-r f14" ><i className="bi bi-pencil-square"></i> Edit</Button>
														{
															deleteId !== undefined && deleteId === qlink && deleteLoad ? (
																<Button className="btn-disable f14" ><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
															) : (
																<Button onClick={() => {
																	deleteLink(qlink);
																	setDeleteId(qlink);
																}} className="btn-disable f14" ><i className="bi bi-trash"></i> Delete</Button>
															)
														}
													</td>
												</tr>
											))
										}
									</tbody>
								</Table>

							) : ''
						) : 'Fetching data...'

					}
				</Col>
			</Row>
			<Modal size="lg" show={addLinkModal} backdrop="static" onHide={() => { setAddlinkModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>
						{
							serverError !== undefined && serverError ? (
								<span className='error-text' >Something went wrong!</span>
							) : (
								linkEdit !== undefined ? 'Update Quick link' : 'Add Quick link'
							)
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addLink} >
						<Form.Group className="mb-3" >
							<Form.Label className="tp2">Service name {servReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={linkEdit !== undefined ? linkEdit.data.name : ''} type="text" name="service" className="shadow-none br-2" placeholder="Service name" />
						</Form.Group>
						<Form.Group className="mb-3" >
							<Form.Label className="tp2">Website name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={linkEdit !== undefined ? linkEdit.data.website : ''} type="text" name="website" className="shadow-none br-2" placeholder="Website name" />
						</Form.Group>
						<Form.Group className="mb-3" >
							<Form.Label className="tp2">Link {urlReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={linkEdit !== undefined ? linkEdit.data.link : ''} type="url" name="link" className="shadow-none br-2" placeholder="Website url" />
						</Form.Group>
						<div className="d-grid">
							{
								addLinkLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1">SUBMIT</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</Container>

	)
}